import Head from 'next/head';
import React from 'react';
import PropTypes from 'prop-types';
import appConfig from '../config/app.json';

export const PageMeta = ({ title, description, type, image, brandName }) => {
  const seoDescription = description || appConfig.defaultSeoDescription;
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={seoDescription} />
      <meta key="robots" name="robots" content="follow,index" />
      <meta key="ogTitle" property="og:title" content={title} />
      {brandName && (
        <meta key="ogSiteName" property="og:site_name" content={brandName} />
      )}
      {type && <meta key="ogType" property="og:type" content={type} />}
      <meta
        key="ogDescription"
        property="og:description"
        content={seoDescription}
      />
      <meta
        key="ogImage"
        property="og:image"
        content={image || '/static/fallbackImages/metadataFallback.png'}
      />
      <meta key="ogLocale" property="og:locale" content="nl_NL" />
    </Head>
  );
};

PageMeta.defaultProps = {
  description: null,
  type: 'website',
  image: null,
  brandName: null,
};

PageMeta.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  type: PropTypes.string,
  image: PropTypes.string,
  brandName: PropTypes.string,
};
